module.exports = __webpack_public_path__ + "img/F904.2faaa4c1.jpg";